/**
 * Live-filters the blog post cards rendered on the current blog page.
 * Each `.blog-post-item` carries a lowercase `data-search-text` built in Liquid
 * (title, tags and excerpt).
 */
class BlogSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.form = this.querySelector('form');
    this.root = this.closest('blog-posts-list') || document;
    this.status = this.root.querySelector('[data-blog-search-status]');
    this.empty = this.root.querySelector('[data-blog-search-empty]');
    if (!this.input) return;

    this.onInput = this.onInput.bind(this);
    this.onSubmit = (event) => event.preventDefault();
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.input.value) {
        this.input.value = '';
        this.filter('');
      }
    };

    this.input.addEventListener('input', this.onInput);
    this.input.addEventListener('keydown', this.onKeydown);
    this.form?.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.onInput);
    this.input?.removeEventListener('keydown', this.onKeydown);
    this.form?.removeEventListener('submit', this.onSubmit);
    clearTimeout(this.timer);
  }

  onInput() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.filter(this.input.value), 150);
  }

  filter(rawQuery) {
    const terms = rawQuery.trim().toLowerCase().split(/\s+/).filter(Boolean);
    const items = this.root.querySelectorAll('.blog-post-item');
    const grid = this.root.querySelector('.blog-posts-container');
    let visible = 0;

    items.forEach((item) => {
      const text = item.dataset.searchText || item.textContent.toLowerCase();
      const match = terms.every((term) => text.includes(term));
      item.hidden = !match;
      if (match) visible += 1;
    });

    grid?.classList.toggle('is-searching', terms.length > 0);
    if (this.empty) this.empty.hidden = visible > 0 || terms.length === 0;
    if (this.status) {
      this.status.textContent = terms.length
        ? `${visible} ${visible === 1 ? 'result' : 'results'}`
        : '';
    }
  }
}

if (!customElements.get('blog-search')) {
  customElements.define('blog-search', BlogSearch);
}
